function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0a10 10 0 100 20 10 10 0 000-20zm4.5 14.5l-5.3-2.961a1.967 1.967 0 01-.633-.695A1.9 1.9 0 018.333 10V2.5H10l1.5 6.667 4.167 4.166L14.5 14.5z",
  fill: "#404040"
});

function SvgTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTimeIcon;